import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';
import { DeparturePickerSlider } from '../components/departure-picker-slider.js';

const $detailsNavBusPackageTab = $('#details-nav-bus-package-tab');

$(() => {
    if ($('.page-type-details').length && $('.booking-tabs').length) {
        $detailsNavBusPackageTab.on('shown.bs.tab', e => {

            const $target = $(e.currentTarget);
            const isLoaded = $target.attr('data-isloaded');

            $('.departure-bus-ticket').removeClass('d-none');
            $('.departure-sopstveni').addClass('d-none');

            ! isLoaded && detailsPackage.init();
        });
    } else {
        if ($('.page-type-details').length && [1,2].includes(+$('#booking').attr('data-dynamicpackage'))) {
            detailsPackage.init();
        }
    }
});

const detailsPackage = {
    $details: null,
    $booking: null,
    $form: null,
    form: null,
    $cart: null,
    cart: [],
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        aDateFrom: null,
        aDateTo: null,
        objectGroupId: null,
        calcErrorMessages: null,
        dynamicPackage: null,
        time: null,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
    },
    init() {
        this.$details = $('.page-type-details');
        this.$booking = $('#booking');
        this.params.objectGroupId = this.$booking.attr('data-objectgroupid');
        this.params.dynamicPackage = +this.$booking.attr('data-dynamicpackage'); 

        this.isBookingTabs = $('.booking-tabs').length;

        /*if( ! (this.$details[0] && this.params.objectGroupId === "1" && [1,2].includes(this.params.dynamicPackage))) {
            return;
        }*/

        this.$form = $('.availability-form-package');
        this.form = this.$form[0];

        this.params.objectId = this.$booking.attr('data-objectid');
        this.params.referenceId = this.$booking.attr('data-referenceid');
        this.params.calcErrorMessages = this.$booking.attr('data-calcErrorMessages') ? JSON.parse(this.$booking.attr('data-calcErrorMessages')) : null;
        this.allowedServices = $('[data-allowedservices]').attr('data-allowedservices');
        this.allowedServices = this.allowedServices ? JSON.parse(this.allowedServices) : [];

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }

        this.$form.on('submit', e => {
            e.preventDefault();
            let params = functions.getFormData($(e.currentTarget));
            //this.params.unitId = null;
            functions.setUrlData(params, true, true);
        });

        this.prepareAvailabilityForm();

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $(window).on('hashchange', e => {
            this.getParams();
            this.params.dynamicPackage = 2;
            //this.params.guests = this.params.adultsOnly ? this.params.guests.split(',')[0] + ',0' : this.params.guests;
            this.showTransportTicket();
            this.setActiveDeparture();
            this.setUnitPrices();

            //this.getCalculation(this.params);
            $detailsNavBusPackageTab.hasClass('active') && this.getCalculation(this.params);
            //$detailsNavBusPackageTab.hasClass('active') && this.params.calcPerService && details.getCalculationPerService(detailsPackage, $("#details-nav-bus-package"), this.params);
        });

        if(this.$cart.length) {
            const $btnBooking = $('.btn-booking');

            $btnBooking.on('click', e => {
                e.preventDefault();
                let cartData = [];

                detailsPackage.cart.cartItems.forEach(item => {
                    item = JSON.parse(item);
                    cartData.push({
                        'unitId': item.unitId,
                        'dateFrom': item.dateFrom,
                        'dateTo': item.dateTo,
                        'aDateFrom': item.aDateFrom,
                        'aDateTo': item.aDateTo,
                        'guests': item.guests,
                        'flightUnitId': item.transportUnitId,
                        'placeFromId': item.placeFromId,
                        'time': item.time,
                        'serviceCode': item.serviceCode,
                        'serviceId': item.serviceId,
                        'pricelistId': detailsPackage.params.pricelistId,
                        'dynamicPackage': detailsPackage.params.dynamicPackage
                    });
                });

                if(detailsPackage.cart.cartItems.length) {
                    location = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=' + detailsPackage.params.dynamicPackage;
                } else {
                    $('#detailsCartModal').modal('show');
                    setTimeout(() => {
                        $('#detailsCartModal').modal('hide');
                    }, 2500);
                }
            });
        }
        else {
            $(document).on('click', '.unit .btn-book-one-unit', e => {

                e.preventDefault();
                const $btnBooking = $(e.currentTarget);

                if (! detailsPackage.params.dateFrom || ! detailsPackage.params.dateTo || ! detailsPackage.params.guests) {
                    window.setAlertBooking($btnBooking);
                    return;
                }

                const unitId = $btnBooking.attr('data-unitid');

                let cartData = {
                    'unitId': unitId,
                    'dateFrom': detailsPackage.params.dateFrom,
                    'dateTo': detailsPackage.params.dateTo,
                    'aDateFrom': detailsPackage.params.aDateFrom,
                    'aDateTo': detailsPackage.params.aDateTo,
                    'time': detailsPackage.params.time,
                    'guests': detailsPackage.params.guests,
                    'flightUnitId': detailsPackage.params.transportUnitId,
                    'placeFromId': detailsPackage.params.placeFromId,
                    'pricelistId': $btnBooking.attr('data-pricelistid'),
                    'serviceCode': $btnBooking.attr('data-servicecode') ? encodeURIComponent($btnBooking.attr('data-servicecode')) : null,
                    'serviceId': $btnBooking.attr('data-serviceid'),
                    'dynamicPackage': detailsPackage.params.dynamicPackage
                };

                let extras = $btnBooking.attr('data-extra');
                if (extras) {
                    extras = JSON.parse(extras);

                    Object.keys(extras).forEach(function(key) {
                        let val = extras[key];
                        if (key === 'optionRefId') {
                            val = encodeURIComponent(val);
                        } else if (key === 'cancellationPolicy') {
                            return;
                        }
                        cartData[key] = val;
                    });
                }

                location = $(e.currentTarget).attr('data-href') + '?dynamicPackage='+detailsPackage.params.dynamicPackage+'&cart_data=' + JSON.stringify([cartData]);
            });

        }

    },
    prepareAvailabilityForm() {
        $('.tickets').append('<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>');
        $.post('/services/dynamic_package_availability_form_data/', {
            objectId: this.params.referenceId,
            dynamicPackage: 2, //this.params.dynamicPackage,
            language: functions.getLang(),
            flightAvailabilityStatus: true,
            placeFromId: this.params.placeFromId,
        }).always(response => {
            response = response ? JSON.parse(response) : null;

            if (response.status) {
                const prepared = this.getPackageDepartures(response.data.items, response.data.flights);
                this.departurePoints = response.data.departurePoints;
                const serviceCodes = response.data.serviceCodes;
                //const $nights = $("[name='nights']");

                this.enable = prepared.enable;
                this.flights = prepared.flights;
                this.prices = response.data.items; // prepared.prices;

                const $service = $("[name='serviceCode']");
                const $serviceWrapper = $service.parents('.service-code-wrapper');
                if (serviceCodes.length) {
                    $serviceWrapper.removeClass('d-none')
                    serviceCodes.forEach((serviceCode, key) => {
                        this.allowedServices.forEach((allowedService) => {
                            if (allowedService.key === serviceCode) {
                                serviceCodes[key] = {id: allowedService.key};
                                serviceCodes[key].text = allowedService.text;

                            }
                        });
                    });

                    $service.select2({
                        data: serviceCodes,
                        minimumResultsForSearch: -1
                    });
                } else {
                    $serviceWrapper.addClass('d-none');
                }

                let nights = this.enable.map(i => i['nights']);
                nights = nights.filter((value, index, array) => array.indexOf(value) === index).sort((a, b) => {
                    return a - b
                });

                if (nights.length) {
                    $('.package-duration-wrapper').removeClass('d-none');
                    $('.package-duration').text(nights.join(', ') + ' noćenja');

                    let _nights = [];
                    nights.forEach((night, key) => {
                        _nights.push({id: night, text: night})

                        if (!this.params.nights) {
                            this.params.nights = night;
                        }
                    });

                    /*$nights.select2({
                        data: _nights,
                        minimumResultsForSearch: -1
                    });*/

                    //setTimeout(() => $nights.val(this.params.nights).trigger('change'));

                } else {
                    $('.package-duration-wrapper').addClass('d-none');
                }

                const $bookingCalendarSlider = $('#booking-calendar-slider');
                $bookingCalendarSlider.attr('data-departures', JSON.stringify(this.enable));
                $bookingCalendarSlider.attr('data-flights', JSON.stringify(this.flights));
                $bookingCalendarSlider.attr('data-prices', JSON.stringify(this.prices));
                new DeparturePickerSlider($bookingCalendarSlider);

                //const $detailsDatepicker = $("#details-datepicker");
                //$detailsDatepicker.attr('data-departures', JSON.stringify(this.enable));
                //$detailsDatepicker.attr('data-flights', JSON.stringify(this.flights));
                //$detailsDatepicker.attr('data-prices', JSON.stringify(this.prices));
                //$detailsDatepicker.attr('data-departurePoints', JSON.stringify(this.departurePoints));

                /*$detailsDatepicker.find('[data-input]').each((i, elem) => {
                    elem._departurePicker = new DeparturePicker(elem);
                });*/

                this.setDefaultDeparture();
                this.setActiveDeparture();
                // dodati input fieldove hidden?
                functions.setFormData(this.form, this.params);

                // showFlightTickets must MANDATORY be after setFormData
                this.params.dateFrom && this.showTransportTicket();
                //this.params.dynamicPackage == 2 && this.setDeparturePoints();
                this.setDeparturePoints();
                this.setUnitPrices();

                //this.getCalculation();

                this.$form.on('change', e => {
                    e.preventDefault();
                    const $target = $(e.currentTarget);
                    const data = functions.getFormData($target);

                    //this.params.dateFrom = data.dateFrom;
                    //this.params.dateTo = data.dateTo;
                    //this.params.time = data.time;
                    //this.params.duration = data.duration;
                    //this.params.transportUnitId = data.transportUnitId;
                    this.params.guests = data.guests;
                    this.params.placeFromId = data.placeFromId;
                    this.params.serviceCode = data.serviceCode;

                    functions.setUrlData(
                        {
                            'dateFrom': this.params.dateFrom,
                            'dateTo': this.params.dateTo,
                            'aDateFrom': this.params.aDateFrom,
                            'aDateTo': this.params.aDateTo,
                            'guests': this.params.guests,
                            'time': this.params.time,
                            'duration': this.params.duration,
                            'transportUnitId': this.params.transportUnitId,
                            'placeFromId': this.params.placeFromId,
                            'serviceCode': this.params.serviceCode,
                        },
                        true,
                        true);
                });

                $(document).on('click', '.ticket', e => {
                    //this.setTransportTicket($(e.currentTarget), true);
                });

                let travelProgramIds = [];
                response.data.flights.forEach((flight) => {
                    if (flight.travelProgramId ) {
                        travelProgramIds.push(flight.travelProgramId);
                    }
                });

                //his.getTravelProgram(travelProgramIds);

                $('#details-nav-bus-package-tab').attr('data-isloaded', 1);

            }
        });
    },
    getPackageDepartures(rates, flightTitles) {
        let departures = {};

        Object.keys(rates).forEach(index => {
            let rate = rates[index];
            let flight = rate.flight;
            // let unique = rate.dateFrom + ',' + rate.dateTo + ',' + flight.timeDepartureFrom + ',' + flight.timeReturnFrom;
            //let unique = rate.aDateFrom + ',' + rate.aDateTo + ',' + rate.dateFrom + ',' + rate.dateTo;
            let unique = rate.dateFrom + ',' + rate.dateTo;
            
            let aDateFrom = rate.aDateFrom;
            let aDateTo = rate.aDateTo;

            let flightUnitId = flight.unitId;

            if ( flight.timeDepartureFrom ) {
                flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
            }

            let flightUnique = flightUnitId + (flight.time ? '_' + flight.time : '');

            if ( ! departures[unique]) {
                let flights = {};
                flights[flightUnique] = flight;

                let rates = {};
                rates[rate.id] = rate;

                departures[unique] = {
                    'dateFrom'      : rate.dateFrom,
                    'dateTo'        : rate.dateTo,
                    'aDateFrom'     : aDateFrom,
                    'aDateTo'       : aDateTo,
                    'time'          : flight.time || '',
                    'duration'      : rate.accommodationDuration,
                    'nights'        : rate.accommodationDuration,
                    'flightUnitId'  : flightUnitId,
                    'flights'       : flights,
                    'rates'         : rates,
                    'price'         : rate.price,
                    'numberOfPersons': rate.numberOfPersons,
                    'available'      : rate.available
                };
            } else {
                let departure = departures[unique];
                departure.flights[flightUnique] = flight;
                departure.rates[rate.id] = rate;

                // ako je price manji od prethodnog, spremi njega
                let numberOfPersons = +rate.numberOfPersons;
                let departurePrice = +departure.price;
                let ratePrice = +rate.price;

                if (numberOfPersons) {
                    departurePrice /= +departure.numberOfPersons;
                    ratePrice /= numberOfPersons;
                }

                if (ratePrice < departurePrice) {
                    departures[unique].price = rate.price;
                    departures[unique].numberOfPersons = rate.numberOfPersons;
                }

                if (rate.available) {
                    departures[unique].available = rate.available;
                }
            }
        });

        this.departures = departures;

        let enable = [];
        let prices = {};
        let flights = [];

        Object.keys(departures).forEach(index => {
            let rate = departures[index];

            enable.push({
                dateFrom: rate['dateFrom'],
                dateTo: rate['dateTo'],
                aDateFrom: rate['aDateFrom'],
                aDateTo: rate['aDateTo'],
                duration: rate['duration'],
                nights: rate['duration'],
                time: rate['time'],
                flightUnitId: rate['flightUnitId'],
                weekDayFrom: detailsPackage.getWeekDay(rate['dateFrom']),
                rates: rate['rates'],
                price: rate['price'],
                numberOfPersons: rate['numberOfPersons'],
                available: rate['available'],
            });

            let arrival = rate.dateFrom;
            let departure = rate.dateTo;

            let departureDay = detailsPackage.getWeekDay(arrival);
            let returnArrivalDay = detailsPackage.getWeekDay(departure);

            Object.keys(rate.flights).forEach(function(index) {

                let flight = rate.flights[index];

                if ( flight.timeDepartureFrom ) {
                    flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
                }

                let timeDepartureFrom = flight['timeDepartureFrom'];
                let timeDepartureTo = flight['timeDepartureTo'];
                let timeReturnFrom = flight['timeReturnFrom'];
                let timeReturnTo = flight['timeReturnTo'];
                let placeFromId = flight['placeFromId'];
                let placeFromName = flight['placeFrom'];
                let placeToName = flight['placeTo'];
                let departureDuration = flight['departureDuration'];
                let returnDuration = flight['returnDuration'];
                let arrivalDate = flight['arrivalDate'];
                let returnDate = flight['returnDate'];
                let availabilityStatus = flight['availabilityStatus'];

                let flightTitle;
                let flightSmallImg;
                let travelProgramId;
                flightTitles.forEach((ft) => {
                    if (ft.id == flight.objectId) {
                        flightTitle = ft.title ? ft.title : ft.supplierTitle;
                        flightSmallImg = ft.images.small ? ft.images.small : '';
                        travelProgramId = ft.travelProgramId;
                    }
                });

                let arrivalDay = detailsPackage.getWeekDay(arrivalDate);
                let returnDepartureDay = detailsPackage.getWeekDay(returnDate);
                
                flights.push({
                    duration              : rate.duration,
                    dateFrom              : rate.dateFrom,
                    dateTo                : rate.dateTo,    
                    aDateFrom             : rate.aDateFrom,
                    aDateTo               : rate.aDateTo,
                    flightId              : flight.objectId,
                    flightTitle           : flightTitle,
                    flightSmallImg        : flightSmallImg,
                    travelProgramId       : travelProgramId,
                    flightUnitId          : flight.unitId,
                    departureDay          : departureDay,
                    returnDepartureDay    : returnDepartureDay,
                    arrivalDay            : arrivalDay,
                    returnArrivalDay      : returnArrivalDay,
                    timeDepartureFrom     : timeDepartureFrom,
                    timeDepartureTo       : timeDepartureTo,
                    timeReturnFrom        : timeReturnFrom,
                    timeReturnTo          : timeReturnTo,
                    time                  : flight.time,
                    placeFromId           : placeFromId,
                    placeFromName         : placeFromName,
                    placeToName           : placeToName,
                    departureDuration     : departureDuration,
                    returnDuration        : returnDuration,
                    arrivalDate           : arrivalDate,
                    returnDate            : returnDate,
                    availabilityStatus    : availabilityStatus,
                });
            });

        });

        return {
            enable : enable,
            prices : prices,
            flights : flights
        };

    },
    getWeekDay(date) {

        const d = new Date(date);
        const days = [
            "nedelja",
            "ponedeljak",
            "utorak",
            "sreda",
            "četvrtak",
            "petak",
            "subota"
        ];

        let day = d.getDay()

        return days[day];
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates === '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    showTransportTicket() {
        const dataTransport = JSON.parse($('[data-flights]').attr('data-flights'));

        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;

        let duration = this.params.duration;
        let time = this.params.time != ' ' && (this.params.time && ! this.params.time.startsWith('null')) ? this.params.time : null;

        if (duration) {
            if (! $('.duration-item[data-datefrom="' + dateFrom + '"][data-dateto="' + dateTo + '"][data-duration="' + duration + '"]').length) {
                duration = this.params.duration = null;
            }
        }

        if (! duration && $('.duration-item.active').length) {
            duration && $('.duration-item.active').attr('data-duration');
        }

        let tickets = dataTransport.filter(ticket => {
            return ticket.dateFrom == dateFrom 
                && ticket.dateTo == dateTo 
                && (duration ? ticket.duration == duration : true)
                && (time ? ticket.time == time : true);
        });

        tickets.sort((a, b) => {
            return a.duration - b.duration;
        });

        this.renderTransportTickets(tickets);
    },
    renderTransportTickets(tickets) {
        if (tickets.length) {
            let ticket = tickets[0];
            let placeFromName = ticket.placeFromName;
    
            if (this.departurePoints && this.params.placeFromId) {
                this.departurePoints.forEach(departurePoint => {
                    if (departurePoint.placeId == this.params.placeFromId) {
                        placeFromName = departurePoint.placeName;
                    }
                });
            }
    
            $('.departure-departureFrom').html(`
                <div><span class="fw-bold">${placeFromName}</span> <small>${functions.formatDate(ticket.dateFrom)} - ${ticket.departureDay}</small></div> 
                <div><span class="fw-bold">${ticket.placeToName}</span> <small>${functions.formatDate(ticket.arrivalDate)} - ${ticket.arrivalDay}</small></div> 
            `);
            $('.departure-departureTo').html(`
                <div><span class="fw-bold">${ticket.placeToName}</span> <small>${functions.formatDate(ticket.returnDate)} - ${ticket.returnDepartureDay}</small></div> 
                <div><span class="fw-bold">${placeFromName}</span> <small>${functions.formatDate(ticket.dateTo)} - ${ticket.returnArrivalDay}</small></div> 
            `);
    
            $('.accordion-summary .departure-departureFrom').html(`
                ${placeFromName} - ${ticket.placeToName}
            `);
        }
    },
    setDefaultDeparture() {
        this.params.dateFrom = ! this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateFrom : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateTo : this.params.dateTo;

        let departure = this.departures ? this.departures[this.params.dateFrom + ',' + this.params.dateTo] : null;
        ! this.params.time && departure && (this.params.time = departure.time);
        
        departure = departure || this.departures[this.params.dateFrom + ',' + this.params.dateTo + ',' + this.params.time]
        this.params.aDateFrom = departure && departure.aDateFrom ? departure.aDateFrom : null;
        this.params.aDateTo = departure && departure.aDateTo ? departure.aDateTo : null;
        this.params.transportUnitId = departure && departure.flightUnitId ? departure.flightUnitId : null;
    },
    setActiveDeparture() {
        $('.departure').removeClass('active');

        if (this.params.dateFrom) {
            const $departure = $('.departure[data-dateFrom="' + this.params.dateFrom + '"]');
            $departure.addClass('active');

            const departure = $departure.attr('data-departure') ? JSON.parse($departure.attr('data-departure')) : {};
            const $departureSelection = $('.departure-selection');

            $departureSelection.find('.departure-dateFrom').text(functions.formatDate(departure.dateFrom) + ' - ' + functions.formatDate(departure.dateTo));
            $departureSelection.find('.departure-duration').text(departure.nights + ' noćenja');

            $('.accordion-summary .departure-dateFrom').text(functions.formatDate(departure.dateFrom) + ' - ' + functions.formatDate(departure.dateTo));
        }

        if (this.params.guests) {
            let guests = this.params.guests.split(',');
            $('.details-cart').find('.departure-guests').html(`
                ${ guests[0] } odrasli${ +guests[1] ? ', ' + guests[1] + ( +guests[1] == 1 ? ' dete' : ' dece') : ''}
            `);
        } else {
            $('.details-cart').find('.departure-guests').html(`
                <a href="" data-scroll-to="#booking,120">Odaberite broj gosta</a>
            `);
        }

    },
    getCalculation(params) {
        const cParams = params ? params : this.params;
        const calculation = details.getCalculation(cParams);

        if(calculation) {
            details.unitsSpinner();
            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                }).fail(error => {
                console.log(error);
            });
        } else {

            //$('.block-no-dates').removeClass('d-none');
            //$('.block-discount').removeClass('d-none');
            //$('.block-loading').addClass('d-none');
        }

        //$('.block-totals-per-service').addClass('d-none');
        //$('.block-booking').addClass('d-none');
        //$('.block-error-msg').addClass('d-none');
    },
    calculationDone(response, params) {
        if(response.status) {
            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = this.isBookingTabs ? $('#details-nav-bus-package .unit[data-unitid=' + unitId + ']') : $('.unit[data-unitid=' + unitId + ']');
                const $addToCart = $unit.find('.add-to-cart');
                const isBookable = details.isBookable(unitData);
                
                if (isBookable) {
                    const unitCalc = unitData.calc;
                    const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                    const calcItems = unitCalc.items;

                    let priceOld = 0.00;
                    let discountTitle = null;

                    calcItems.forEach(item => {
                        // popust za djecu ne ulazi u prikaz discount cijene
                        if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                            priceOld += item.itemTotal;
                        }
                        if (item.itemType == 'discount') {
                            discountTitle = item.itemTitle;
                            if (item.data && item.data.text) {
                                discountTitle = item.data.text;
                            }
                        }
                    });

                    let hasDiscount = priceOld && priceOld != unitCalc.total ? priceOld : null;

                    const totalOld = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');

                    $unit.find('.price').html(total);

                    if (hasDiscount) {
                        priceOld && $unit.find('.price-old').html(totalOld);
                        discountTitle && $unit.find('.badge-discount').html(discountTitle);
                        discountTitle && $unit.find('.badge-discount').removeClass('d-none');
                    } else {
                        $unit.find('.price-old').html('');
                        $unit.find('.badge-discount').addClass('d-none');
                    }

                    $unit.parent().prop('style', 'order: ' + Math.round(unitCalc.total) + ';');

                    $unit.find('.price').toggleClass('text-danger', priceOld > unitCalc.total);

                    $addToCart.attr('data-unitcarttotal', unitCalc.total);
                    $addToCart.attr('data-unitcarttotalold', priceOld);
                    $addToCart.attr('data-currencysymbol', unitCalc.currencySymbol);
                    
                    $addToCart.attr('data-datefrom', detailsPackage.params.dateFrom);
                    $addToCart.attr('data-dateto', detailsPackage.params.dateTo);
                    $addToCart.attr('data-guests', detailsPackage.params.guests);

                    $addToCart.attr('data-adatefrom', detailsPackage.params.aDateFrom);
                    $addToCart.attr('data-adateto', detailsPackage.params.aDateTo);
                    $addToCart.attr('data-transportunitid', detailsPackage.params.transportUnitId);
                } else {
                    $unit.parent().prop('style', 'order: 100000;');
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.unit-error-message').toggleClass('d-none', isBookable || unitData.message == "notAvailable");
                $unit.find('.unit-error-message').text(error);

                $unit.find('.rate-container').toggleClass('d-none', ! isBookable);
                $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-book-one-unit').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-request').toggleClass('d-none', isBookable);

                $unit.find('.price-from-label').toggleClass('d-none', isBookable);
                $unit.find('.total-label').toggleClass('d-none', ! isBookable);

            });

            if(this.$cart.length && ! this.$cart.data('isgds')) {
                const $btnBooking = $('.btn-booking');

                $btnBooking.on('click', e => {
                    e.preventDefault();
                    let cartData = [];

                    this.cart.cartItems.forEach(item => {
                        item = JSON.parse(item);
                        cartData.push({
                            'unitId': item.unitId,
                            'dateFrom': item.dateFrom,
                            'dateTo': item.dateTo,
                            'aDateFrom': item.aDateFrom,
                            'aDateTo': item.aDateTo,
                            'guests': item.guests,
                            'serviceCode': item.serviceCode,
                            'serviceId': item.serviceId,
                            'pricelistId': params.pricelistId,
                            'dynamicPackage': 2,
                        });
                    });
                    let url = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=2';

                    if(this.cart.cartItems.length) {
                        location = url;
                    } else {
                        $('#detailsCartModal').modal('show');
                        setTimeout(() => {
                            $('#detailsCartModal').modal('hide');
                        }, 2500);
                    }
                });
            } else {

                detailsPackage.getParams();

                $('.btn-book-one-unit').on('click', e => {
                    const $target = $(e.currentTarget); 
                    let cartData = [
                        {
                            'unitId': $target.attr('data-unitId'),
                            'dateFrom': detailsPackage.params.dateFrom,
                            'dateTo': detailsPackage.params.dateTo,
                            'aDateFrom': detailsPackage.params.aDateFrom,
                            'aDateTo': detailsPackage.params.aDateTo,
                            'guests': detailsPackage.params.guests,
                            'serviceCode': detailsPackage.params.serviceCode,
                            'dynamicPackage': 2,
                        }
                    ];

                    location = $target.attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=2'; // &dynamicPackage=0
                });
            }
        }
    },
    setDeparturePoints () {
        const $placeFromId = $('[name="placeFromId"]');
        $placeFromId.empty();

        // ali first zapamtiti i vratiti ga na prvo misto
        if (this.departurePoints) {
            const defaultDeparture = this.departurePoints[0];

            this.departurePoints.sort((a, b) => {
                return a.placeName.localeCompare(b.placeName);
            });

            const itemIndex = this.departurePoints.findIndex(item => item == defaultDeparture);
            if (itemIndex) {
                const [ item ] = this.departurePoints.splice(itemIndex, 1); // delete itemIndex
                this.departurePoints.unshift(item); // add at first index
            }
    
            this.departurePoints.forEach(departurePoints => {
                const newOption = new Option(departurePoints.placeName, departurePoints.placeId, false, this.params.placeFromId == departurePoints.placeId);
                $placeFromId.append(newOption);
            });
        }

    },
    setUnitPrices() {
        if (! this.params.guests) {
            let dataPrices = JSON.parse($('[data-prices]').attr('data-prices'));
            dataPrices = Object.values(dataPrices);

            const $bookingUnits = this.isBookingTabs ? $('#details-nav-bus-package .unit.card') : $('#booking .unit.card');
    
            $bookingUnits.each((index, unit) => {
                const $unit = $(unit);
                const unitId = $unit.attr('data-unitId');
                const unitBeds = $unit.attr('data-beds');
    
                let unitRate = dataPrices.find(rate => {
                    if(
                        this.params.dateFrom == rate.dateFrom 
                        && this.params.dateTo == rate.dateTo 
                        && unitId == rate.unitId.id 
                        && (! rate.numberOfPersons || rate.numberOfPersons == unitBeds)
                    ) {
                        return rate;
                    }
                });
                
                let unitPrice = unitRate ? unitRate.price : null;
                if (unitRate && unitRate.numberOfPersons) {
                    unitPrice /= unitRate.numberOfPersons;
                }
    
                unitPrice && $unit.find('.price').text(functions.formatMoney(unitPrice, 0, '.', ','));
            });
        }
    },
}